<template>
  <div class="project-milestone">
    <div class="project-milestone-header">
      <div>
        <svg-icon icon-class="display_project-milestone" class="milestone-header-icon" />
        项目里程碑
      </div>
      <div class="header-button-list">
        <base-button type="primary" style="margin-right: 10px;" @click="exportExcel">
          导出
        </base-button>
        <dropdown-menu
          :menu-list="menuList"
          placement="bottom-end"
          @click="clickBtn"
          trigger="hover"
        >
          <base-button size="normal" style="width: 32px;padding: 0">
            <i class="el-icon-more"></i>
          </base-button>
        </dropdown-menu>
      </div>
    </div>
    <div class="project-milestone-main">
      <TimeLine
        :milestone-list="milestoneList"
        class="milestone-time-line"
        @hasToday="hasToday = true"
      ></TimeLine>
      <MilestoneTaskTable
        :projectId="projectId"
        :milestone-list="milestoneList"
        @data-changed="refreshTable"
        class="milestone-main-table"
        :style="hasToday ? ' height: calc(100% - 264px);' : 'height: calc(100% - 232px);'"
      ></MilestoneTaskTable>
    </div>
    <base-dialog :show-close="true" :visible.sync="versionDialogVisible">
      <template v-slot:header>保存为版本</template>
      <el-form :model="version" :rules="rules" label-width="100px" style="margin-top: 10px">
        <el-form-item label="版本名称" prop="versionCode">
          <el-input v-model="version.versionCode" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="更新内容" prop="upContent">
          <el-input
            v-model="version.upContent"
            :autosize="{ minRows: 2, maxRows: 6 }"
            type="textarea"
            resize="none"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <span class="dialog-footer">
          <base-button @click="versionDialogVisible = false">取 消</base-button>
          <base-button type="primary" @click="createMilestoneVersion">确 认</base-button>
        </span>
      </template>
    </base-dialog>
    <HistoryVersionDialog ref="historyVersion" :projectId="projectId"></HistoryVersionDialog>
  </div>
</template>

<script>
import TimeLine from "@/views/Front/Project/Milestone/components/TimeLine.vue"
import BaseButton from "@/components/UIComponents/Button.vue"
import MilestoneTaskTable from "@/views/Front/Project/Milestone/components/MilestoneTaskTable.vue"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"
import HistoryVersionDialog from "@/views/Front/Project/Milestone/components/HistoryVersionDialog.vue"
import { createMilestoneHistory, getMilestoneTasks } from "@/api/project/project"
import { exportExcel } from "@/views/Backend/Admin/Layout/mixin/export2Excel"
import { milestoneTableColumns } from "@/views/Front/Project/Milestone/static"

export default {
  name: "project-milestone",
  components: {
    HistoryVersionDialog,
    BaseDialog,
    DropdownMenu,
    MilestoneTaskTable,
    BaseButton,
    TimeLine
  },
  data() {
    return {
      versionDialogVisible: false,
      version: {},
      milestoneList: [],
      projectId: String,
      hasToday: false,
      menuList: [
        {
          title: "保存为版本",
          command: "save-version"
        },
        {
          title: "查看历史版本",
          command: "history-version"
        }
      ],
      rules: {
        versionCode: [{ required: true, message: "请输入版本号", trigger: "blur" }]
      }
    }
  },
  created() {
    this.projectId = this.$route.params?.projectId
    this.init()
  },
  methods: {
    async init() {
      this.milestoneList = await getMilestoneTasks(this.projectId)
      this.getCycle()
    },
    clickBtn(operation) {
      switch (operation) {
        case "save-version":
          this.versionDialogVisible = true
          break
        case "history-version":
          this.$refs.historyVersion.open()
          break
      }
    },
    // 后一个项目的时间减去前一个项目的时间 算出具体的周期天数
    getCycle() {
      if (this.milestoneList == undefined || this.milestoneList?.length == 0) return
      for (let i = 0; i < this.milestoneList.length; i++) {
        this.milestoneList[i].dueDateStr = this.getDaysBetweenDates(
          this.milestoneList[i - 1]?.dueDate,
          this.milestoneList[i]?.dueDate
        )
        this.milestoneList[i].completeAtStr = this.getDaysBetweenDates(
          this.milestoneList[i - 1]?.completeAt,
          this.milestoneList[i]?.completeAt
        )
      }
    },
    getDaysBetweenDates(date1, date2) {
      if (date1 === undefined || date2 === undefined) return ""
      let d1 = new Date(date1)
      let d2 = new Date(date2)
      let timeDiff = Math.abs(d2.getTime() - d1.getTime())
      return Math.ceil(timeDiff / (1000 * 3600 * 24))
    },
    async createMilestoneVersion() {
      await createMilestoneHistory(this.version, this.projectId).then(() =>
        this.$message.success("版本保存成功")
      )
      this.versionDialogVisible = false
    },
    refreshTable() {
      this.init()
    },
    // 导出里程碑任务Excel
    exportExcel() {
      let th = milestoneTableColumns.map(column => column.label)
      let tData = this.milestoneList.map(milestone => {
        let m_key = milestoneTableColumns.map(column => column.prop)
        let m_list = []
        m_key.forEach(k => m_list.push(milestone[k]))
        return m_list
      })
      exportExcel(th, tData, "里程碑")
    }
  }
}
</script>

<style scoped lang="scss">
.project-milestone {
  .project-milestone-header {
    height: 52px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 500;
    color: #313132;
    line-height: 25px;

    .milestone-header-icon {
      font-size: 24px;
      color: #f5f7fa;
      padding: 0 5px 0 16px;
    }

    .header-button-list {
      padding-right: 20px;
      display: flex;
      align-items: center;
    }
  }

  width: 100%;
  height: 100%;

  .project-milestone-main {
    width: 100%;
    height: calc(100% - 52px);
    background: #f5f7fa;
    padding: 16px;
  }
}
</style>
